/**
 * i18n resources for @f2e/ui
 *
 * These resources can be merged into your app's i18n configuration.
 */
import en from "./locales/en.json";
import zhTW from "./locales/zh-TW.json";
import ja from "./locales/ja.json";
export const uiResources = {
    en,
    "zh-TW": zhTW,
    ja,
};
//# sourceMappingURL=resources.js.map